import React from 'react';

const Loading = React.memo(() => {
    return (
        <>LOADING...</>
    );
});

export default Loading;
